import type { FieldValidationError } from '../errors/types';

export const prepareErrorsArray = (errorsById: {
	[id: string]: FieldValidationError[];
}): FieldValidationError[] => Object.values(errorsById).flat();
